import AvApi from '@availity/api-axios';
import { getDeveloperHubApiUrl } from '../config';

export interface SubscriptionData {
  key: string;
  key_type: string;
  key_id: string;
  user_id: string;
  org_id: string;
  org_name: string;
  creation_time: string;
  expiration_time: string;
  status: string;
}

class SubscriptionApi extends AvApi {
  constructor() {
    super({
      url: getDeveloperHubApiUrl('subscription-details'),
      api: false,
      withCredentials: true,
      sessionBust: false,
    });
  }

  getSubscriptionDetails(): Promise<SubscriptionData[]> {
    return this.query({}).then((res) => res.data);
  }
}

export default new SubscriptionApi();
